import React, { Component } from "react";

const empty = (v) => (v == null || v === "" ? "" : v);

export default class SentenceCompletion extends Component {
  render() {
    var {
      sentence_completion_q1_s1,
      sentence_completion_q1_s2,
      sentence_completion_q1_s3,
      sentence_completion_q1_s4,
      sentence_completion_score,
    } = this.props.data;
    const fields = [
      {
        name: "sentence_completion_q1_s1",
        label: "1. He called the restaurant to reserve a",
        value: sentence_completion_q1_s1,
      },
      {
        name: "sentence_completion_q1_s2",
        label: "2. When she got up in the morning, the sun was",
        value: sentence_completion_q1_s2,
      },
      {
        name: "sentence_completion_q1_s3",
        label: "1. He called the restaurant to reserve a",
        value: sentence_completion_q1_s3,
      },
      {
        name: "sentence_completion_q1_s4",
        label: "2. When she got up in the morning, the sun was",
        value: sentence_completion_q1_s4,
      },
    ];
    return (
      <div className="row border border-dark sentense_completion_section sentence-completion-section">
        <div className="col-12 sentence-completion-inner">
          <div className="sentence-completion-grid" role="list">
            {fields.map((f) => (
              <div
                key={f.name}
                className="sentence-completion-item"
                role="listitem"
              >
                <p className="sentence-completion-prompt">{f.label}</p>
                <input
                  disabled
                  type="text"
                  name={f.name}
                  value={empty(f.value)}
                  className="ecas-input-field sentence-completion-field"
                />
              </div>
            ))}
          </div>
          <hr className="sentence-completion-divider" />
          <div className="col-lg-6">
            <br />
            <span className="fs-19">Score </span>
            <input
              type="number"
              disabled
              name="sentence_completion_score"
              value={empty(sentence_completion_score)}
              className="ecas-input-field"
              placeholder="Score"
            />
          </div>
        </div>
      </div>
    );
  }
}
